import React, {useState} from 'react';
import AppRoutes from '../src/routes'
import {BrowserRouter} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css"
import ScrollToTop from "./ScrollToTop";

import { I18nextProvider } from 'react-i18next';
import { SpeedInsights } from '@vercel/speed-insights/react';
import i18n from './i18n';



function App() {

    // const { t, i18n } = useTranslation();

    return (

        <>
            <I18nextProvider i18n={i18n}/>
            <BrowserRouter basename="/">
            <ScrollToTop/>
            <div className="App">
                <AppRoutes/>
                <SpeedInsights />
            </div>
        </BrowserRouter></>
        // </I18nextProvider>
    );
}


export default App;
